import Masonry from 'masonry-layout'

document.querySelectorAll('.mod_newslist.news-feed').forEach((container) => {
    new Masonry(container.querySelector('.news-feed__items'), {
        itemSelector: '.news-feed__item',
        horizontalOrder: true
    });
})

document.querySelectorAll('[data-news-feed]').forEach(async (container) => {
    const itemsContainer = container.querySelector('.news-feed__items');
    const emptyContainer = container.querySelector('.news-feed__empty');
    const categoriesContainer = container.querySelector('.news-feed__filtered-categories');
    const moreContainer = container.querySelector('.news-feed__more');
    const clearButton = container.querySelector('.news-feed__filtered-clear');
    const filterKeywords = container.querySelector('.news-feed__filter input[name="keywords"]');
    const filterFrom = container.querySelector('.news-feed__filter *[name="from"]');
    const filterTo = container.querySelector('.news-feed__filter *[name="to"]');
    const filterCategories = container.querySelectorAll('.news-feed__filter *[name="category"]');
    const filterFeatured = container.querySelector('.news-feed__filter *[name="featured"]');

    let currentPage = 0;
    const feedUrl = container.getAttribute('data-news-feed');

    const msnry = new Masonry(itemsContainer, {
        itemSelector: '.news-feed__item'
    });
    msnry.remove(itemsContainer.children);
    msnry.layout();

    const moreButton = moreContainer.firstElementChild;
    const moreButtonTitle = moreButton.querySelector('span');
    const moreButtonLabel = moreButtonTitle.innerText;
    const updateMoreButton = (loading, hide = false) => {
        moreContainer.style.display = hide ? 'none' : 'block';

        if (loading) {
            moreButton.classList.add('loading');
            moreButtonTitle.innerText = moreButtonTitle.getAttribute('data-loading');
        } else {
            moreButton.classList.remove('loading');
            moreButtonTitle.innerText = moreButtonLabel;
        }
    }

    const selectedDate = document.createElement('div');
    const updateDate = () => {
        let label = '';
        let labelFrom = '';
        selectedDate.remove();

        if (filterFrom.value) {
            label = `${filterFrom.nextElementSibling.innerHTML} ${filterFrom.options[filterFrom.selectedIndex].innerHTML}`
            labelFrom = filterFrom.options[filterFrom.selectedIndex].innerHTML;
        }

        if (filterTo.value) {
            label = `${labelFrom} ${filterTo.nextElementSibling.innerHTML} ${filterTo.options[filterTo.selectedIndex].innerHTML}`
        }

        if (label !== '') {
            selectedDate.innerHTML = label;
            categoriesContainer.prepend(selectedDate);
        }
    }
    selectedDate.addEventListener('click', () => {
        filterFrom.value = '';
        filterTo.value = '';
        updateDate();
        loadItems();
    });

    filterFeatured.addEventListener('change', () => {
        updateCategories([filterFeatured.value], !!filterFeatured.checked);
        loadItems();
    });

    let selectedCategories = [];
    const updateCategories = (ids, addOrRemove = null) => {
        selectedCategories = addOrRemove === true ? selectedCategories.concat(ids) : (addOrRemove === false ? selectedCategories.filter(id => !ids.includes(id)) : ids);
        Array.from(categoriesContainer.children).forEach(el => { el.remove() });

        filterCategories.forEach((cat) => {
            const value = cat.value;
            const checked = selectedCategories.includes(value);
            cat.checked = checked;

            if (value === filterFeatured.value) {
                filterFeatured.checked = checked;
            }

            if (checked) {
                const active = document.createElement('div');
                active.innerHTML = cat.nextElementSibling.innerHTML;
                categoriesContainer.append(active);

                active.addEventListener('click', () => {
                    updateCategories([value], false);
                    loadItems();
                });
            }
        })

        updateDate();
    }

    const loadItems = async (page = 1) => {
        updateMoreButton(true)
        emptyContainer.style.display = 'none';
        clearButton.style.display = (filterKeywords.value !== '' || filterFrom.value !== '' || filterTo.value !== '' || !!Array.from(filterCategories).find(cat => cat.checked)) ? 'block' : 'none';

        if (page === 1) {
            msnry.remove(itemsContainer.children);
            msnry.layout();
        }

        const searchParams = new URLSearchParams();
        if (filterKeywords.value) searchParams.set('keywords', filterKeywords.value);
        if (filterFrom.value) searchParams.set('from', String(filterFrom.value));
        if (filterTo.value) searchParams.set('to', String(filterTo.value));
        if (page > 1) searchParams.set('page', String(page));

        const ids = [];
        filterCategories.forEach((cat) => {
            if (cat.checked) {
                ids.push(cat.value);
            }
        })
        searchParams.set('categories', ids.join(','))

        const currLocation = new URL(location.href);
        currLocation.hash = searchParams.toString();
        history.replaceState({}, '', currLocation.toString());

        const feed = new URL(feedUrl);
        searchParams.set('pageId', feed.searchParams.get('pageId'));
        feed.search = searchParams.toString();

        const data = await (await fetch(feed.toString())).json();

        if (data.articles.length > 0) {
            data.articles.forEach((article) => {
                const el = document.createElement('div');
                el.innerHTML = article;

                const item = el.firstElementChild;
                item.querySelectorAll('[data-news-category]').forEach((cat) => {
                    const id = cat.getAttribute('data-news-category');
                    cat.style.cursor = 'pointer';
                    cat.addEventListener('click', (e) => {
                        e.preventDefault();
                        updateCategories([id])
                        window.scroll(0, 0);
                        loadItems();
                    });
                });

                itemsContainer.append(item);
                msnry.appended(item);
                msnry.layout();
            });

            updateMoreButton(false, data.perPage * page >= data.total);
        } else if (page === 1) {
            emptyContainer.style.display = 'block';
            updateMoreButton(false, true);
        }

        currentPage = page;
    };

    container.querySelector('.news-feed__pagination').remove()
    container.querySelector('.news-feed__filter').style.display = 'inherit';

    let keyboardDelay;
    filterKeywords.addEventListener('input', () => {
        clearTimeout(keyboardDelay);
        keyboardDelay = setTimeout(() => {
            loadItems();
        }, 300)
    });

    filterFrom.addEventListener('change', () => { updateDate(); loadItems(); });
    filterTo.addEventListener('change', () => { updateDate(); loadItems(); });
    filterCategories.forEach((cat) => {
        cat.addEventListener('change', () => {
            updateCategories(cat.value, cat.checked);
            loadItems();
        });
    });

    clearButton.addEventListener('click', () => {
        filterKeywords.value = '';
        filterKeywords.detect();
        filterFrom.value = '';
        filterTo.value = '';
        updateCategories([]);
        loadItems();
    });

    moreContainer.firstElementChild.addEventListener('click', (e) => {
        e.preventDefault();
        loadItems(currentPage+1);
    });

    const dateToggle = container.querySelector('.news-feed__filter-date h3');
    const categoriesToggle = container.querySelector('.news-feed__filter-categories h3');
    dateToggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        dateToggle.parentNode.classList.toggle('news-feed__filter-date--open');
        categoriesToggle.parentNode.classList.remove('news-feed__filter-categories--open');
    });

    categoriesToggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        categoriesToggle.parentNode.classList.toggle('news-feed__filter-categories--open');
        dateToggle.parentNode.classList.remove('news-feed__filter-date--open');
    });

    document.body.addEventListener('click', (e) => {
        if (dateToggle.parentNode.contains(e.target) || categoriesToggle.parentNode.contains(e.target)) {
            return;
        }
        dateToggle.parentNode.classList.remove('news-feed__filter-date--open');
        categoriesToggle.parentNode.classList.remove('news-feed__filter-categories--open');
    }, false);

    const currLocation = new URL(location.href);
    if (currLocation.hash) {
        const hash = new URLSearchParams(currLocation.hash.substring(1));
        const page = hash.get('page');
        const offset = history.state && history.state['news-feed-offset'] || undefined

        filterKeywords.value = hash.get('keywords') || '';
        filterKeywords.detect();
        filterFrom.value = hash.get('from') || '';
        filterTo.value = hash.get('to') || '';
        updateDate();

        const ids = (hash.get('categories') || '').split(',');
        updateCategories(ids);

        await loadItems();

        if (page > 1) {
            for (let i = 1; i <= page; i++) {
                await loadItems(i);
            }

            if (offset) {
                window.scroll(0, offset);
            }
        }
    } else {
        await loadItems();
    }

    window.addEventListener('beforeunload', () => {
        history.replaceState({ 'news-feed-offset': window.scrollY }, '', location.href);
    });
})
